import { Link } from "react-router-dom";
import { Leaf, Mail, Phone, MapPin } from "lucide-react";

export default function Footer({ contact }) {
  return (
    <footer className="mt-10 bg-[var(--brand-navy-deep)] text-white/80" data-testid="main-footer">
      <div className="container-xl grid gap-10 py-16 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src="/ehp-logo.jpg" alt="EHP" className="h-12 w-12 rounded-full bg-white object-contain" />
            <div>
              <div className="font-serif text-2xl text-white">ECONOMIC H PHARMACY (EHP)</div>
            </div>
          </div>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-white/60">
            EHP crafts gentle, natural homeopathic remedies rooted in classical principles and
            eco-conscious care — supporting your body's own path to wellness.
          </p>
        </div>

        <div>
          <h4 className="font-display text-sm uppercase tracking-widest text-white/90">Explore</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/about-us" className="hover:text-white">About Us</Link></li>
            <li><Link to="/products" className="hover:text-white">Our Products</Link></li>
            <li><Link to="/about-homeopathy" className="hover:text-white">About Homeopathy</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm uppercase tracking-widest text-white/90">Reach Us</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/60">
            {contact?.phone && (
              <li className="flex items-start gap-2"><Phone className="mt-0.5 h-4 w-4 text-accent" /> {contact.phone}</li>
            )}
            {contact?.email && (
              <li className="flex items-start gap-2"><Mail className="mt-0.5 h-4 w-4 text-accent" /> {contact.email}</li>
            )}
            {contact?.address && (
              <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 text-accent" /> {contact.address}</li>
            )}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-xl flex flex-col items-center justify-between gap-2 py-6 text-xs text-white/50 sm:flex-row">
          <span>© {new Date().getFullYear()} EHP — ECONOMIC H PHARMACY. All rights reserved.</span>
          <span className="flex items-center gap-1"><Leaf className="h-3.5 w-3.5 text-accent" /> Natural Homeopathic Wellness</span>
        </div>
      </div>
    </footer>
  );
}
